import { useState, useEffect, useCallback } from 'react';
import request from '../utils/request';
import type { PhoneItem } from '../types/admin';

const usePhonesManage = () => {
  const [data, setData] = useState<PhoneItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await request.get<PhoneItem[]>('/allowed-phones');
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err: unknown) {
      console.error(err instanceof Error ? err.message : '获取手机号列表失败');
    } finally {
      setLoading(false);
    }
  }, []);

  const addPhone = useCallback(
    (phone: string) => {
      return request.post<null>('/allowed-phones/add', { phone }).then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData],
  );

  const deletePhone = useCallback(
    (id: number | string) => {
      return request.post<null>('/allowed-phones/delete', { id }).then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, addPhone, deletePhone };
};

export default usePhonesManage;